import { api } from "@/lib/api/client";
import type {
  AuditLogResponse,
  ExplorerEntity,
  ExplorerResponse,
  ExplorerTimeRange,
  FeatureFlagsResponse,
  FeatureFlagToggleResponse,
  InspectPaymentResponse,
  PendingTicketsResponse,
  ReconcileResponse,
  SweepSummary,
} from "./types";

// ── Salud MP ─────────────────────────────────────────────────────────
// Prefix /api/mercadopago (ver app.ts:648).
export const mpHealthApi = {
  listPending: async (olderThanMinutes: number): Promise<PendingTicketsResponse> => {
    const { data } = await api.get<PendingTicketsResponse>(
      "/api/mercadopago/pending-tickets",
      { params: { olderThanMinutes } },
    );
    return data;
  },
  forceSweep: async (olderThanMinutes: number): Promise<SweepSummary> => {
    const { data } = await api.post<SweepSummary>(
      `/api/mercadopago/reconcile-sweep?olderThanMinutes=${olderThanMinutes}`,
    );
    return data;
  },
  reconcileById: async (transactionId: number): Promise<ReconcileResponse> => {
    const { data } = await api.post<ReconcileResponse>(
      `/api/mercadopago/reconcile/${transactionId}`,
    );
    return data;
  },
};

// ── Auditoría MP ─────────────────────────────────────────────────────
// Prefix /api/matrix (ver app.ts:632).
export const mpAuditApi = {
  inspect: async (paymentId: string): Promise<InspectPaymentResponse> => {
    const { data } = await api.get<InspectPaymentResponse>(
      `/api/matrix/mp/inspect-payment/${encodeURIComponent(paymentId)}`,
    );
    return data;
  },
  recent: async (limit = 10): Promise<AuditLogResponse> => {
    const { data } = await api.get<AuditLogResponse>(
      "/api/matrix/mp/audit-recent",
      { params: { limit } },
    );
    return data;
  },
};

// ── Feature Flags ────────────────────────────────────────────────────
// Prefix /api/features (ver app.ts:634). getAll es público; toggle
// requiere requirePermission(OPS_FEATURES_TOGGLE).
export const featuresApi = {
  list: async (): Promise<FeatureFlagsResponse> => {
    const { data } = await api.get<FeatureFlagsResponse>("/api/features");
    return data;
  },
  toggle: async (key: string, enabled: boolean): Promise<FeatureFlagToggleResponse> => {
    const { data } = await api.put<FeatureFlagToggleResponse>(
      `/api/features/${encodeURIComponent(key)}/toggle`,
      { enabled },
    );
    return data;
  },
};

// ── Explorer ─────────────────────────────────────────────────────────
// Prefix /api/matrix (ver app.ts:632).
export const explorerApi = {
  query: async (
    entity: ExplorerEntity,
    params: { take?: number; skip?: number; timeRange?: ExplorerTimeRange },
  ): Promise<ExplorerResponse> => {
    const { data } = await api.get<ExplorerResponse>(
      `/api/matrix/explore/${entity}`,
      {
        params: {
          take: params.take ?? 500,
          skip: params.skip ?? 0,
          timeRange: params.timeRange ?? "24h",
        },
      },
    );
    return data;
  },
};
